/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Select_AllInputs */

const cs_property_ai_select_all = /** @type {(inputs: Property_Ai_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat vše`)
};

const en_property_ai_select_all = /** @type {(inputs: Property_Ai_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all`)
};

/**
* | output |
* | --- |
* | "Select all" |
*
* @param {Property_Ai_Select_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_select_all = /** @type {((inputs?: Property_Ai_Select_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Select_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_select_all(inputs)
	return cs_property_ai_select_all(inputs)
});